// extracted by mini-css-extract-plugin
export var arrowIcon = "FooterNavigationSection-module--arrowIcon--9ef7d";
export var divider = "FooterNavigationSection-module--divider--93933";
export var navButton = "FooterNavigationSection-module--navButton--1076c";
export var navButtonArrow = "FooterNavigationSection-module--navButtonArrow--5d7af";
export var navButtonArrowIcon = "FooterNavigationSection-module--navButtonArrowIcon--45fd1";
export var navButtonContent = "FooterNavigationSection-module--navButtonContent--c06f6";
export var navButtonList = "FooterNavigationSection-module--navButtonList--c1d22";
export var navButtonListContainer = "FooterNavigationSection-module--navButtonListContainer--391b4";
export var navLink = "FooterNavigationSection-module--navLink--d7809 variables-module--linkEffect--b3f97";
export var navList = "FooterNavigationSection-module--navList--fdedd";
export var navListContainer = "FooterNavigationSection-module--navListContainer--cfbf3";
export var navSection = "FooterNavigationSection-module--navSection--31984";
export var navSectionContainer = "FooterNavigationSection-module--navSectionContainer--2230c";
export var noticeMark = "FooterNavigationSection-module--noticeMark--8f909";
export var noticeSection = "FooterNavigationSection-module--noticeSection--f0aef";
export var noticeText = "FooterNavigationSection-module--noticeText--38b42";